import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandNationalRegistry(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M12.0004 2.40002L15.2004 5.60002L6.88039 11.36L12.0004 21.6L8.16039 11.04L16.4804 6.88002L20.3204 10.72L11.6804 12.96L12.0004 21.6L2.40039 12L12.0004 2.40002Z"
        fill="#5F666E"
      />
      <path d="M13.28 13.28L21.6 12L12 21.6L13.28 13.28Z" fill="#7DA0B4" />
    </BaseIcon>
  );
}
